import { classDiaryPermissionLabels } from './classDiaryAccess';
const normalizePermissionName = (name) => {
  if (!name) return '';
  return name
    .normalize('NFD')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_')
    .toUpperCase();
};

const ADMIN_ALIASES = ['ADMINISTRADOR', 'ADMIN'];
const FORM_MANAGER_ALIASES = ['GERENCIAR_FORMULARIOS', 'MANAGE_FORMS'];
const REGISTRATION_UPDATE_ALIASES = ['ALTERAR_CADASTROS', 'UPDATE_REGISTRATIONS'];
const REGISTRATION_DELETE_ALIASES = ['EXCLUIR_CADASTROS', 'DELETE_REGISTRATIONS'];
const REGISTRATION_MANAGER_ALIASES = ['GERENCIAR_CADASTROS', 'MANAGE_REGISTRATIONS'];
const REGISTRATION_VIEW_ALIASES = [
  'VISUALIZAR_CADASTROS',
  'VIEW_REGISTRATIONS',
  ...REGISTRATION_MANAGER_ALIASES,
];
const FINANCE_MANAGER_ALIASES = ['GERENCIAR_FINANCEIRO', 'MANAGE_FINANCE'];
const FINANCE_VIEW_ALIASES = [
  'VISUALIZAR_FINANCEIRO',
  'VIEW_FINANCE',
  ...FINANCE_MANAGER_ALIASES,
];
const INVENTORY_MANAGER_ALIASES = ['GERENCIAR_ESTOQUE', 'MANAGE_INVENTORY'];
const INVENTORY_VIEW_ALIASES = [
  'VISUALIZAR_ESTOQUE',
  'VIEW_INVENTORY',
  ...INVENTORY_MANAGER_ALIASES,
];

const CRM_MANAGER_ALIASES = ['GERENCIAR_CRM', 'MANAGE_CRM'];
const CRM_VIEW_ALIASES = ['VISUALIZAR_CRM', 'VIEW_CRM', ...CRM_MANAGER_ALIASES];

const HUMAN_RESOURCES_MANAGER_ALIASES = [
  'GERENCIAR_RECURSOS_HUMANOS',
  'GERENCIAR_RH',
  'MANAGE_HUMAN_RESOURCES',
  'MANAGE_HR',
];

const HUMAN_RESOURCES_VIEW_ALIASES = [
  'VISUALIZAR_RECURSOS_HUMANOS',
  'VISUALIZAR_RH',
  'VIEW_HUMAN_RESOURCES',
  'VIEW_HR',
  ...HUMAN_RESOURCES_MANAGER_ALIASES,
];

const ASSET_MANAGER_ALIASES = [
  'GERENCIAR_PATRIMONIO',
  'MANAGE_ASSETS',
];
const ASSET_VIEW_ALIASES = [
  'VISUALIZAR_PATRIMONIO',
  'VIEW_ASSETS',
  ...ASSET_MANAGER_ALIASES,
];
const PROJECT_BANK_CREATE_ALIASES = ['CRIAR_BANCO_PROJETOS', 'CREATE_PROJECT_BANK_PROJECT'];
const PROJECT_BANK_DELETE_ALIASES = ['EXCLUIR_BANCO_PROJETOS', 'DELETE_PROJECT_BANK_PROJECT'];
const PROJECT_BANK_UPDATE_ALIASES = ['ALTERAR_BANCO_PROJETOS', 'UPDATE_PROJECT_BANK_PROJECT'];
const PROJECT_BANK_SETTINGS_VIEW_ALIASES = ['VISUALIZAR_CONFIGURACOES_BANCO_PROJETOS', 'VIEW_PROJECT_BANK_SETTINGS'];
const PROJECT_BANK_PROJECTS_TAB_VIEW_ALIASES = ['ACESSAR_ABA_PROJETOS_BANCO_PROJETOS', 'VIEW_PROJECT_BANK_PROJECTS_TAB'];
const PROJECT_BANK_MANAGER_ALIASES = ['GERENCIAR_BANCO_PROJETOS', 'MANAGE_PROJECT_BANK', ...PROJECT_BANK_CREATE_ALIASES, ...PROJECT_BANK_DELETE_ALIASES, ...PROJECT_BANK_UPDATE_ALIASES];
const PROJECT_BANK_VIEW_ALIASES = ['VISUALIZAR_BANCO_PROJETOS', 'VIEW_PROJECT_BANK', ...PROJECT_BANK_MANAGER_ALIASES, ...PROJECT_BANK_PROJECTS_TAB_VIEW_ALIASES];

const MENU_PERMISSION_ALIASES = {
  VISUALIZAR_MENU_DASHBOARD: [
    'VISUALIZAR_MENU_DASHBOARD',
    'VIEW_MENU_DASHBOARD',
    'VIEW_DASHBOARD_MENU',
  ],
  VISUALIZAR_MENU_AUTOMACOES: [
    'VISUALIZAR_MENU_AUTOMACOES',
    'VIEW_MENU_AUTOMACOES',
    'VIEW_MENU_AUTOMATIONS',
    'VIEW_AUTOMATION_MENU',
  ],
  VISUALIZAR_MENU_SOLICITACOES: [
    'VISUALIZAR_MENU_SOLICITACOES',
    'VIEW_MENU_SOLICITACOES',
    'VIEW_MENU_REQUESTS',
  ],
  VISUALIZAR_MENU_STUDIO: [
    'VISUALIZAR_MENU_STUDIO',
    'VIEW_MENU_STUDIO',
  ],
  VISUALIZAR_MENU_CURSOS: [
    'VISUALIZAR_MENU_CURSOS',
    'VIEW_MENU_COURSES',
  ],
  VISUALIZAR_MENU_ASSISTENTE_IA: [
    'VISUALIZAR_MENU_ASSISTENTE_IA',
    'VIEW_MENU_ASSISTANT_AI',
    'VIEW_ASSISTANT_MENU',
  ],
  VISUALIZAR_MENU_FORMULARIOS: [
    'VISUALIZAR_MENU_FORMULARIOS',
    'VIEW_MENU_FORMS',
  ],
  VISUALIZAR_MENU_PROCESSOS: [
    'VISUALIZAR_MENU_PROCESSOS',
    'VIEW_MENU_PROCESSES',
  ],
  VISUALIZAR_MENU_ARQUIVOS: [
    'VISUALIZAR_MENU_ARQUIVOS',
    'VIEW_MENU_FILES',
  ],
  VISUALIZAR_MENU_AGENDA: [
    'VISUALIZAR_MENU_AGENDA',
    'VIEW_MENU_AGENDA',
    'VIEW_MENU_CALENDAR',
  ],
  VISUALIZAR_MENU_NEGOCIO: [
    'VISUALIZAR_MENU_NEGOCIO',
    'VIEW_MENU_BUSINESS',
  ],
  VISUALIZAR_MENU_CRM: [
    'VISUALIZAR_MENU_CRM',
    'VIEW_MENU_CRM',
  ],
  VISUALIZAR_MENU_CONFIGURACOES: [
    'VISUALIZAR_MENU_CONFIGURACOES',
    'VIEW_MENU_CONFIGURACOES',
    'VIEW_MENU_SETTINGS',
  ],
  VISUALIZAR_MENU_CADASTROS: [
    'VISUALIZAR_MENU_CADASTROS',
    'VISUALIZAR_MENU_CENTRAL_DE_CADASTROS',
    'VIEW_MENU_REGISTRATIONS',
    'VIEW_REGISTRATION_CENTER_MENU',
  ],
  VISUALIZAR_MENU_DADOS_CADASTRAIS: [
    'VISUALIZAR_MENU_DADOS_CADASTRAIS',
    'VIEW_MENU_COMPANY_PROFILE',
  ],
  VISUALIZAR_MENU_FINANCEIRO: [
    'VISUALIZAR_MENU_FINANCEIRO',
    'VIEW_MENU_FINANCE',
  ],
  VISUALIZAR_MENU_ESTOQUE: [
    'VISUALIZAR_MENU_ESTOQUE',
    'VIEW_MENU_INVENTORY',
  ],
  VISUALIZAR_MENU_PATRIMONIO: [
    'VISUALIZAR_MENU_PATRIMONIO',
    'VIEW_MENU_ASSETS',
  ],
  VISUALIZAR_MENU_RECURSOS_HUMANOS: [
    'VISUALIZAR_MENU_RECURSOS_HUMANOS',
    'VIEW_MENU_HUMAN_RESOURCES',
  ],
  VISUALIZAR_MENU_ORGANOGRAMA: [
    'VISUALIZAR_MENU_ORGANOGRAMA',
    'VIEW_MENU_ORGANOGRAM',
    'VIEW_MENU_ORG_CHART',
  ],
  VISUALIZAR_MENU_BANCO_PROJETOS: [
    'VISUALIZAR_MENU_BANCO_PROJETOS',
    'VIEW_MENU_PROJECT_BANK',
  ],
  VISUALIZAR_MENU_GESTAO_DE_ALUNOS: [
    'VISUALIZAR_MENU_GESTAO_DE_ALUNOS',
    'VIEW_MENU_STUDENT_MANAGEMENT',
  ],
  VISUALIZAR_MENU_GESTAO_DE_ATENDIDOS: [
    'VISUALIZAR_MENU_GESTAO_DE_ATENDIDOS',
    'VIEW_MENU_ATTENDEE_MANAGEMENT',
  ],
  VISUALIZAR_MENU_GRUPOS: [
    'VISUALIZAR_MENU_GRUPOS',
    'VIEW_MENU_GRUPOS',
    'VIEW_GROUPS_MENU',
  ],
  VISUALIZAR_MENU_USUARIOS: [
    'VISUALIZAR_MENU_USUARIOS',
    'VIEW_MENU_USUARIOS',
    'VIEW_USERS_MENU',
  ],
  VISUALIZAR_MENU_AUDITORIA: [
    'VISUALIZAR_MENU_AUDITORIA',
    'VIEW_MENU_AUDITORIA',
    'VIEW_AUDIT_MENU',
  ],
  VISUALIZAR_MENU_EMAIL: [
    'VISUALIZAR_MENU_EMAIL',
    'VIEW_MENU_EMAIL',
    'VIEW_MAIL_MENU',
  ],
  VISUALIZAR_MENU_MANUAL_DO_USUARIO: [
    'VISUALIZAR_MENU_MANUAL_DO_USUARIO',
    'VIEW_MENU_MANUAL_DO_USUARIO',
    'VIEW_USER_MANUAL_MENU',
  ],
  VISUALIZAR_MENU_PERFIL: [
    'VISUALIZAR_MENU_PERFIL',
    'VIEW_MENU_PERFIL',
    'VIEW_PROFILE_MENU',
  ],
  VISUALIZAR_MENU_MINHA_EQUIPE: [
    'VISUALIZAR_MENU_MINHA_EQUIPE',
    'VIEW_MENU_MINHA_EQUIPE',
    'VIEW_MY_TEAM_MENU',
  ],
  VISUALIZAR_MENU_LIXEIRA: [
    'VISUALIZAR_MENU_LIXEIRA',
    'VIEW_MENU_LIXEIRA',
    'VIEW_TRASH_MENU',
    'VIEW_MENU_TRASH',
  ],
};

const PERMISSION_ALIASES = {
/* young-apprentice-granular-permissions-v1 */
  VISUALIZAR_DASHBOARDS_JOVEM_APRENDIZ: ['VISUALIZAR_DASHBOARDS_JOVEM_APRENDIZ'],
  VISUALIZAR_ALUNOS_JOVEM_APRENDIZ: ['VISUALIZAR_ALUNOS_JOVEM_APRENDIZ', 'GERENCIAR_ALUNOS_JOVEM_APRENDIZ'],
  GERENCIAR_ALUNOS_JOVEM_APRENDIZ: ['GERENCIAR_ALUNOS_JOVEM_APRENDIZ'],
  VISUALIZAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ: ['VISUALIZAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ', 'GERENCIAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ'],
  GERENCIAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ: ['GERENCIAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ'],
  VISUALIZAR_EMPRESAS_JOVEM_APRENDIZ: ['VISUALIZAR_EMPRESAS_JOVEM_APRENDIZ', 'GERENCIAR_EMPRESAS_JOVEM_APRENDIZ'],
  GERENCIAR_EMPRESAS_JOVEM_APRENDIZ: ['GERENCIAR_EMPRESAS_JOVEM_APRENDIZ'],
  VISUALIZAR_FALTAS_JOVEM_APRENDIZ: ['VISUALIZAR_FALTAS_JOVEM_APRENDIZ', 'GERENCIAR_FALTAS_JOVEM_APRENDIZ'],
  GERENCIAR_FALTAS_JOVEM_APRENDIZ: ['GERENCIAR_FALTAS_JOVEM_APRENDIZ'],
  VISUALIZAR_NOTA_FATURA_JOVEM_APRENDIZ: ['VISUALIZAR_NOTA_FATURA_JOVEM_APRENDIZ', 'GERENCIAR_NOTA_FATURA_JOVEM_APRENDIZ'],
  GERENCIAR_NOTA_FATURA_JOVEM_APRENDIZ: ['GERENCIAR_NOTA_FATURA_JOVEM_APRENDIZ'],
  VISUALIZAR_RELATORIO_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ: ['VISUALIZAR_RELATORIO_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ'],
  VISUALIZAR_CADASTROS_JOVEM_APRENDIZ: ['VISUALIZAR_CADASTROS_JOVEM_APRENDIZ', 'GERENCIAR_CADASTROS_JOVEM_APRENDIZ'],
  GERENCIAR_CADASTROS_JOVEM_APRENDIZ: ['GERENCIAR_CADASTROS_JOVEM_APRENDIZ'],
  ADMINISTRADOR: ADMIN_ALIASES,
  GERENCIAR_EMPRESA: ['GERENCIAR_EMPRESA', 'MANAGE_COMPANY'],
  GERENCIAR_FORMULARIOS: FORM_MANAGER_ALIASES,
  GERENCIAR_CADASTROS: REGISTRATION_MANAGER_ALIASES,
  ALTERAR_CADASTROS: REGISTRATION_UPDATE_ALIASES,
  EXCLUIR_CADASTROS: REGISTRATION_DELETE_ALIASES,
  VISUALIZAR_CADASTROS: REGISTRATION_VIEW_ALIASES,
  VISUALIZAR_CURSOS: ['VISUALIZAR_CURSOS', 'VIEW_COURSES', 'ALUNO', 'CRIADOR_DE_CONTEUDO', 'GERENCIAR_CURSOS', 'PROFESSOR'],
  VISUALIZAR_EDICAO_CURSOS: ['VISUALIZAR_EDICAO_CURSOS', 'VIEW_COURSE_EDITOR', 'PROFESSOR'],
  GERENCIAR_CURSOS: ['GERENCIAR_CURSOS', 'MANAGE_COURSES', 'CRIADOR_DE_CONTEUDO', 'PROFESSOR'],
  CRIADOR_DE_CONTEUDO: ['CRIADOR_DE_CONTEUDO', 'CONTENT_CREATOR', 'GERENCIAR_CURSOS', 'PROFESSOR'],
  ALUNO: ['ALUNO', 'STUDENT', 'VISUALIZAR_CURSOS', 'VIEW_COURSES'],
  PROFESSOR: ['PROFESSOR', 'TEACHER', 'CRIADOR_DE_CONTEUDO', 'GERENCIAR_CURSOS'],
  COORDENADOR_DE_CURSOS: ['COORDENADOR_DE_CURSOS', 'COURSE_COORDINATOR', 'GERENCIAR_TURMAS'],
  GERENCIAR_TURMAS: ['GERENCIAR_TURMAS', 'MANAGE_COURSE_CLASSES', 'COORDENADOR_DE_CURSOS'],
  GERENCIAR_FINANCEIRO: FINANCE_MANAGER_ALIASES,
  VISUALIZAR_FINANCEIRO: FINANCE_VIEW_ALIASES,
  GERENCIAR_ESTOQUE: INVENTORY_MANAGER_ALIASES,
  VISUALIZAR_ESTOQUE: INVENTORY_VIEW_ALIASES,
  GERENCIAR_CRM: CRM_MANAGER_ALIASES,
  VISUALIZAR_CRM: CRM_VIEW_ALIASES,
  GERENCIAR_RECURSOS_HUMANOS: HUMAN_RESOURCES_MANAGER_ALIASES,
  VISUALIZAR_RECURSOS_HUMANOS: HUMAN_RESOURCES_VIEW_ALIASES,
  GERENCIAR_PATRIMONIO: ASSET_MANAGER_ALIASES,
  VISUALIZAR_PATRIMONIO: ASSET_VIEW_ALIASES,
  GERENCIAR_BANCO_PROJETOS: PROJECT_BANK_MANAGER_ALIASES,
  VISUALIZAR_BANCO_PROJETOS: PROJECT_BANK_VIEW_ALIASES,
  CRIAR_BANCO_PROJETOS: PROJECT_BANK_CREATE_ALIASES,
  EXCLUIR_BANCO_PROJETOS: PROJECT_BANK_DELETE_ALIASES,
  ALTERAR_BANCO_PROJETOS: PROJECT_BANK_UPDATE_ALIASES,
  VISUALIZAR_CONFIGURACOES_BANCO_PROJETOS: PROJECT_BANK_SETTINGS_VIEW_ALIASES,
  ACESSAR_ABA_PROJETOS_BANCO_PROJETOS: PROJECT_BANK_PROJECTS_TAB_VIEW_ALIASES,
  GERENCIAR_ARQUIVOS: ['GERENCIAR_ARQUIVOS', 'MANAGE_FILES'],
  GERENCIAR_PROCESSOS: [
    'GERENCIAR_PROCESSOS',
    'LISTAR_PROCESSOS',
    'LIST_PROCESS',
    'MODELADOR',
  ].map((alias) => normalizePermissionName(alias)),
  EXECUTAR_PROCESSOS: [
    'EXECUTAR_PROCESSOS',
    'EXECUTE_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  MODELADOR: ['MODELADOR', 'CREATE_PROCESS'],
  ATUALIZAR_PROCESSOS: [
    'ATUALIZAR_PROCESSOS',
    'UPDATE_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  BAIXAR_PROCESSOS: [
    'BAIXAR_PROCESSOS',
    'DOWNLOAD_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  EXCLUIR_PROCESSOS: [
    'EXCLUIR_PROCESSOS',
    'DELETE_PROCESS',
    'GERENCIAR_PROCESSOS',
  ],
  LISTAR_FORMULARIOS: ['LISTAR_FORMULARIOS', 'LIST_FORM', ...FORM_MANAGER_ALIASES],
  CRIAR_FORMULARIOS: ['CRIAR_FORMULARIOS', 'CREATE_FORM', ...FORM_MANAGER_ALIASES],
  ATUALIZAR_FORMULARIOS: ['ATUALIZAR_FORMULARIOS', 'UPDATE_FORM', ...FORM_MANAGER_ALIASES],
  EXCLUIR_FORMULARIOS: ['EXCLUIR_FORMULARIOS', 'DELETE_FORM', ...FORM_MANAGER_ALIASES],
  LISTAR_GRUPOS: ['LISTAR_GRUPOS', 'LIST_GROUP'],
  CRIAR_GRUPOS: ['CRIAR_GRUPOS', 'CREATE_GROUP'],
  ATUALIZAR_GRUPOS: ['ATUALIZAR_GRUPOS', 'UPDATE_GROUP'],
  EXCLUIR_GRUPOS: ['EXCLUIR_GRUPOS', 'DELETE_GROUP'],
  LISTAR_PERMISSOES: ['LISTAR_PERMISSOES', 'LIST_PERMISSION'],
  CRIAR_PERMISSOES: ['CRIAR_PERMISSOES', 'CREATE_PERMISSION'],
  ATUALIZAR_PERMISSOES: ['ATUALIZAR_PERMISSOES', 'UPDATE_PERMISSION'],
  EXCLUIR_PERMISSOES: ['EXCLUIR_PERMISSOES', 'DELETE_PERMISSION'],
  LISTAR_USUARIOS: ['LISTAR_USUARIOS', 'LIST_USER'],
  CRIAR_USUARIOS: ['CRIAR_USUARIOS', 'CREATE_USER'],
  ATUALIZAR_USUARIOS: ['ATUALIZAR_USUARIOS', 'UPDATE_USER'],
  EXCLUIR_USUARIOS: ['EXCLUIR_USUARIOS', 'DELETE_USER'],
  CRIAR_AVISOS_MURAL: ['CRIAR_AVISOS_MURAL', 'CREATE_NOTICE_BOARD_POST', 'MANAGE_NOTICE_BOARD'],
  ATUALIZAR_AVISOS_MURAL: ['ATUALIZAR_AVISOS_MURAL', 'UPDATE_NOTICE_BOARD_POST', 'MANAGE_NOTICE_BOARD'],
  EXCLUIR_AVISOS_MURAL: ['EXCLUIR_AVISOS_MURAL', 'DELETE_NOTICE_BOARD_POST', 'MANAGE_NOTICE_BOARD'],
  COMPARTILHAR_EVENTOS: ['COMPARTILHAR_EVENTOS', 'SHARE_CALENDAR_EVENTS'],
  LOGS_DE_INTEGRACAO: ['LOGS_DE_INTEGRACAO', 'INTEGRATION_LOGS', 'VIEW_INTEGRATION_LOGS'],
  VISUALIZAR_GESTAO_DE_ALUNOS: ['VISUALIZAR_GESTAO_DE_ALUNOS', 'GESTAO_DE_ALUNOS', 'VISUALIZAR_ALUNOS_TOTAL', 'VISUALIZAR_ALUNOS_DP'],
  VISUALIZAR_ALUNOS_DP: ['VISUALIZAR_ALUNOS_DP', 'VIEW_STUDENT_PERSONAL_DATA'],
  VISUALIZAR_ALUNOS_TOTAL: ['VISUALIZAR_ALUNOS_TOTAL', 'VIEW_STUDENT_FULL_DATA'],
  VISUALIZAR_CONFIGURACOES_GESTAO_DE_ALUNOS: ['VISUALIZAR_CONFIGURACOES_GESTAO_DE_ALUNOS', 'VIEW_STUDENT_MANAGEMENT_SETTINGS'],
  VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ALUNOS: ['VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ALUNOS', 'VIEW_STUDENT_ATTENDANCE_HISTORY'],
  VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ALUNOS: ['VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ALUNOS', 'VIEW_STUDENT_CLASSES_COURSES'],
  VISUALIZAR_HISTORICO_ALTERACOES_ALUNOS: ['VISUALIZAR_HISTORICO_ALTERACOES_ALUNOS', 'VIEW_STUDENT_CHANGE_HISTORY'],
  GERENCIAR_GESTAO_DE_ALUNOS: ['GERENCIAR_GESTAO_DE_ALUNOS', 'MANAGE_STUDENT_MANAGEMENT'],
  VISUALIZAR_ABA_FAMILIA_ALUNOS: ['VISUALIZAR_ABA_FAMILIA_ALUNOS', 'VIEW_STUDENT_FAMILY_TAB'],
  VISUALIZAR_ABA_AUTORIZACOES_ALUNOS: ['VISUALIZAR_ABA_AUTORIZACOES_ALUNOS', 'VIEW_STUDENT_AUTHORIZATIONS_TAB'],
  VISUALIZAR_ABA_ENDERECO_ALUNOS: ['VISUALIZAR_ABA_ENDERECO_ALUNOS', 'VIEW_STUDENT_ADDRESS_TAB'],
  VISUALIZAR_ABA_SOCIAL_ALUNOS: ['VISUALIZAR_ABA_SOCIAL_ALUNOS', 'VIEW_STUDENT_SOCIAL_TAB'],
  VISUALIZAR_ABA_ESCOLARIDADE_ALUNOS: ['VISUALIZAR_ABA_ESCOLARIDADE_ALUNOS', 'VIEW_STUDENT_EDUCATION_TAB'],
  VISUALIZAR_ABA_SAUDE_ALUNOS: ['VISUALIZAR_ABA_SAUDE_ALUNOS', 'VIEW_STUDENT_HEALTH_TAB'],
  VISUALIZAR_ABA_CURSO_ALUNOS: ['VISUALIZAR_ABA_CURSO_ALUNOS', 'VIEW_STUDENT_COURSE_TAB'],
  VISUALIZAR_ABA_ARQUIVOS_ALUNOS: ['VISUALIZAR_ABA_ARQUIVOS_ALUNOS', 'VIEW_STUDENT_FILES_TAB', 'GERENCIAR_ARQUIVOS_ALUNOS'],
  GERENCIAR_ARQUIVOS_ALUNOS: ['GERENCIAR_ARQUIVOS_ALUNOS', 'MANAGE_STUDENT_FILES'],
  VISUALIZAR_ABA_INTERCORRENCIAS_ALUNOS: ['VISUALIZAR_ABA_INTERCORRENCIAS_ALUNOS', 'VIEW_STUDENT_INCIDENTS_TAB', 'GERENCIAR_INTERCORRENCIAS_ALUNOS'],
  GERENCIAR_INTERCORRENCIAS_ALUNOS: ['GERENCIAR_INTERCORRENCIAS_ALUNOS', 'MANAGE_STUDENT_INCIDENTS'],
  VISUALIZAR_ABAS_EXTRAS_ALUNOS: ['VISUALIZAR_ABAS_EXTRAS_ALUNOS', 'VIEW_STUDENT_CUSTOM_TABS'],
  GERENCIAR_CONFIGURACOES_GESTAO_DE_ALUNOS: ['GERENCIAR_CONFIGURACOES_GESTAO_DE_ALUNOS', 'MANAGE_STUDENT_MANAGEMENT_SETTINGS'],
  GERENCIAR_FREQUENCIA_GESTAO_DE_ALUNOS: ['GERENCIAR_FREQUENCIA_GESTAO_DE_ALUNOS', 'MANAGE_STUDENT_ATTENDANCE'],
  GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ALUNOS: ['GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ALUNOS', 'MANAGE_STUDENT_ABSENCE_JUSTIFICATIONS'],
  VISUALIZAR_GESTAO_DE_ATENDIDOS: ['VISUALIZAR_GESTAO_DE_ATENDIDOS', 'GESTAO_DE_ATENDIDOS', 'VISUALIZAR_ATENDIDOS_TOTAL', 'VISUALIZAR_ATENDIDOS_DP'],
  VISUALIZAR_ATENDIDOS_DP: ['VISUALIZAR_ATENDIDOS_DP', 'VIEW_ATTENDEE_PERSONAL_DATA'],
  VISUALIZAR_ATENDIDOS_TOTAL: ['VISUALIZAR_ATENDIDOS_TOTAL', 'VIEW_ATTENDEE_FULL_DATA'],
  VISUALIZAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS: ['VISUALIZAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS', 'VIEW_ATTENDEE_MANAGEMENT_SETTINGS'],
  VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ATENDIDOS: ['VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ATENDIDOS', 'VIEW_ATTENDEE_ATTENDANCE_HISTORY'],
  VISUALIZAR_TURMAS_GRUPOS_GESTAO_DE_ATENDIDOS: ['VISUALIZAR_TURMAS_GRUPOS_GESTAO_DE_ATENDIDOS', 'VIEW_ATTENDEE_CLASSES_GROUPS', 'VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ATENDIDOS', 'VIEW_ATTENDEE_CLASSES_COURSES'],
  VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ATENDIDOS: ['VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ATENDIDOS', 'VIEW_ATTENDEE_CLASSES_COURSES', 'VISUALIZAR_TURMAS_GRUPOS_GESTAO_DE_ATENDIDOS', 'VIEW_ATTENDEE_CLASSES_GROUPS'],
  VISUALIZAR_HISTORICO_ALTERACOES_ATENDIDOS: ['VISUALIZAR_HISTORICO_ALTERACOES_ATENDIDOS', 'VIEW_ATTENDEE_CHANGE_HISTORY'],
  GERENCIAR_GESTAO_DE_ATENDIDOS: ['GERENCIAR_GESTAO_DE_ATENDIDOS', 'MANAGE_ATTENDEE_MANAGEMENT'],
  GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ATENDIDOS: ['GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ATENDIDOS', 'MANAGE_ATTENDEE_ABSENCE_JUSTIFICATIONS'],
  GERENCIAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS: ['GERENCIAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS', 'MANAGE_ATTENDEE_MANAGEMENT_SETTINGS'],
  GERENCIAR_FREQUENCIA_GESTAO_DE_ATENDIDOS: ['GERENCIAR_FREQUENCIA_GESTAO_DE_ATENDIDOS', 'MANAGE_ATTENDEE_ATTENDANCE'],
  ...MENU_PERMISSION_ALIASES,
};

const LABEL_OVERRIDES = {
  ACESSO_CONFIDENCIAL: 'Acesso a observações confidenciais (Alunos e Atendidos)',
  VISUALIZAR_DASHBOARDS_JOVEM_APRENDIZ: 'Visualizar dashboards - Jovem Aprendiz',
  VISUALIZAR_ALUNOS_JOVEM_APRENDIZ: 'Visualizar alunos - Jovem Aprendiz',
  GERENCIAR_ALUNOS_JOVEM_APRENDIZ: 'Editar alunos - Jovem Aprendiz',
  VISUALIZAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ: 'Consultar Mundo do Trabalho - Jovem Aprendiz',
  GERENCIAR_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ: 'Criar/alterar/excluir Mundo do Trabalho - Jovem Aprendiz',
  VISUALIZAR_EMPRESAS_JOVEM_APRENDIZ: 'Visualizar cadastro de empresas - Jovem Aprendiz',
  GERENCIAR_EMPRESAS_JOVEM_APRENDIZ: 'Editar cadastro de empresas - Jovem Aprendiz',
  VISUALIZAR_FALTAS_JOVEM_APRENDIZ: 'Consultar Registro de Faltas - Jovem Aprendiz',
  GERENCIAR_FALTAS_JOVEM_APRENDIZ: 'Criar/alterar/excluir Faltas - Jovem Aprendiz',
  VISUALIZAR_NOTA_FATURA_JOVEM_APRENDIZ: 'Consultar Nota Fatura - Jovem Aprendiz',
  GERENCIAR_NOTA_FATURA_JOVEM_APRENDIZ: 'Criar/alterar/excluir Nota Fatura - Jovem Aprendiz',
  VISUALIZAR_RELATORIO_MUNDO_DO_TRABALHO_JOVEM_APRENDIZ: 'Consultar Relatório Mundo do Trabalho - Jovem Aprendiz',
  VISUALIZAR_CADASTROS_JOVEM_APRENDIZ: 'Consultar Cadastros - Jovem Aprendiz',
  GERENCIAR_CADASTROS_JOVEM_APRENDIZ: 'Criar/alterar/excluir Cadastros - Jovem Aprendiz',
  GERENCIAR_FORMULARIOS: 'Gerenciar formulários',
  GERENCIAR_CADASTROS: 'Gerenciar cadastros',
  ALTERAR_CADASTROS: 'Alterar cadastros',
  EXCLUIR_CADASTROS: 'Excluir cadastros',
  VISUALIZAR_CADASTROS: 'Visualizar cadastros',
  GERENCIAR_PROCESSOS: 'Gerenciar processos',
  GERENCIAR_ARQUIVOS: 'Gerenciar arquivos',
  GERENCIAR_EMPRESA: 'Gerenciar empresa',
  GERENCIAR_FINANCEIRO: 'Gerenciar financeiro',
  VISUALIZAR_FINANCEIRO: 'Visualizar financeiro',
  GERENCIAR_ESTOQUE: 'Gerenciar estoque',
  VISUALIZAR_ESTOQUE: 'Visualizar estoque',
  GERENCIAR_CRM: 'Gerenciar CRM',
  VISUALIZAR_CRM: 'Visualizar CRM',
  GERENCIAR_PATRIMONIO: 'Gerenciar patrimônio',
  VISUALIZAR_PATRIMONIO: 'Visualizar patrimônio',
  GERENCIAR_BANCO_PROJETOS: 'Gerenciar Banco de Projetos',
  VISUALIZAR_BANCO_PROJETOS: 'Visualizar Banco de Projetos',
  CRIAR_BANCO_PROJETOS: 'Criar projetos',
  EXCLUIR_BANCO_PROJETOS: 'Excluir projetos',
  ALTERAR_BANCO_PROJETOS: 'Alterar projetos',
  VISUALIZAR_CONFIGURACOES_BANCO_PROJETOS: 'Visualizar configurações do Banco de Projetos',
  ACESSAR_ABA_PROJETOS_BANCO_PROJETOS: 'Acessar aba Projetos do Banco de Projetos',
  GERENCIAR_RECURSOS_HUMANOS: 'Gerenciar recursos humanos',
  VISUALIZAR_RECURSOS_HUMANOS: 'Visualizar recursos humanos',
  MODELADOR: 'Modelador',
  COMPARTILHAR_EVENTOS: 'Compartilhar eventos',
  LOGS_DE_INTEGRACAO: 'Logs de integração',
  VISUALIZAR_MENU_DASHBOARD: 'Visualizar menu Dashboard',
  VISUALIZAR_MENU_STUDIO: 'Visualizar menu Studio',
  VISUALIZAR_MENU_AUTOMACOES: 'Visualizar menu Automações',
  VISUALIZAR_MENU_SOLICITACOES: 'Visualizar menu Minhas solicitações',
  VISUALIZAR_MENU_ASSISTENTE_IA: 'Visualizar menu Assistente IA',
  VISUALIZAR_MENU_FORMULARIOS: 'Visualizar menu Formulários',
  VISUALIZAR_MENU_PROCESSOS: 'Visualizar menu Processos',
  VISUALIZAR_MENU_ARQUIVOS: 'Visualizar menu Arquivos',
  VISUALIZAR_MENU_AGENDA: 'Visualizar menu Agenda',
  VISUALIZAR_MENU_NEGOCIO: 'Visualizar menu Meu Negócio',
  VISUALIZAR_MENU_CRM: 'Visualizar menu CRM',
  VISUALIZAR_MENU_CONFIGURACOES: 'Visualizar menu Configurações',
  VISUALIZAR_MENU_CADASTROS: 'Visualizar menu Central de Cadastros',
  VISUALIZAR_MENU_DADOS_CADASTRAIS: 'Visualizar menu Dados Cadastrais',
  VISUALIZAR_MENU_FINANCEIRO: 'Visualizar menu Financeiro',
  VISUALIZAR_MENU_ESTOQUE: 'Visualizar menu Estoque',
  VISUALIZAR_MENU_PATRIMONIO: 'Visualizar menu Patrimônio',
  VISUALIZAR_MENU_RECURSOS_HUMANOS: 'Visualizar menu Recursos Humanos',
  VISUALIZAR_MENU_ORGANOGRAMA: 'Visualizar menu Organograma',
  VISUALIZAR_MENU_BANCO_PROJETOS: 'Visualizar menu Banco de Projetos',
  VISUALIZAR_MENU_GESTAO_DE_ALUNOS: 'Visualizar menu Gestão de Alunos',
  VISUALIZAR_MENU_GRUPOS: 'Visualizar menu Grupos',
  VISUALIZAR_MENU_USUARIOS: 'Visualizar menu Usuários',
  VISUALIZAR_MENU_AUDITORIA: 'Visualizar menu Auditoria',
  VISUALIZAR_MENU_EMAIL: 'Visualizar menu E-mail',
  VISUALIZAR_MENU_MANUAL_DO_USUARIO: 'Visualizar menu Manual do usuário',
  VISUALIZAR_MENU_PERFIL: 'Visualizar menu Perfil',
  VISUALIZAR_MENU_MINHA_EQUIPE: 'Visualizar menu Minha equipe',
  VISUALIZAR_MENU_LIXEIRA: 'Visualizar menu Lixeira',
  VISUALIZAR_GESTAO_DE_ALUNOS: 'Visualizar Gestão de Alunos',
  VISUALIZAR_ALUNOS_DP: 'Visualizar aba Dados Pessoais do aluno',
  VISUALIZAR_ALUNOS_TOTAL: 'Visualizar todas as abas do cadastro do aluno',
  VISUALIZAR_ABA_FAMILIA_ALUNOS: 'Visualizar aba Vínculo Familiar',
  VISUALIZAR_ABA_AUTORIZACOES_ALUNOS: 'Visualizar aba Autorizações',
  VISUALIZAR_ABA_ENDERECO_ALUNOS: 'Visualizar aba Endereço',
  VISUALIZAR_ABA_SOCIAL_ALUNOS: 'Visualizar aba Social',
  VISUALIZAR_ABA_ESCOLARIDADE_ALUNOS: 'Visualizar aba Escolaridade',
  VISUALIZAR_ABA_SAUDE_ALUNOS: 'Visualizar aba Saúde',
  VISUALIZAR_ABA_CURSO_ALUNOS: 'Visualizar aba Curso',
  VISUALIZAR_ABA_ARQUIVOS_ALUNOS: 'Visualizar arquivos do aluno',
  GERENCIAR_ARQUIVOS_ALUNOS: 'Enviar, alterar e excluir arquivos do aluno',
  VISUALIZAR_ABA_INTERCORRENCIAS_ALUNOS: 'Visualizar Intercorrências e Mediações',
  GERENCIAR_INTERCORRENCIAS_ALUNOS: 'Criar, alterar e excluir Intercorrências e Mediações',
  VISUALIZAR_ABAS_EXTRAS_ALUNOS: 'Visualizar abas personalizadas do aluno',
  VISUALIZAR_CONFIGURACOES_GESTAO_DE_ALUNOS: 'Visualizar configurações da Gestão de Alunos',
  VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ALUNOS: 'Visualizar frequência e histórico',
  VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ALUNOS: 'Visualizar turmas e cursos',
  VISUALIZAR_HISTORICO_ALTERACOES_ALUNOS: 'Visualizar histórico de alterações de alunos',
  GERENCIAR_GESTAO_DE_ALUNOS: 'Criar, editar e excluir cadastro básico de alunos',
  GERENCIAR_CONFIGURACOES_GESTAO_DE_ALUNOS: 'Criar/editar/excluir configurações da Gestão de Alunos',
  GERENCIAR_FREQUENCIA_GESTAO_DE_ALUNOS: 'Registrar e editar frequência',
  GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ALUNOS: 'Registrar faltas, justificativas e atestados',
  VISUALIZAR_GESTAO_DE_ATENDIDOS: 'Visualizar Gestão de Atendidos',
  VISUALIZAR_ATENDIDOS_DP: 'Visualizar aba Atendidos - dados pessoais',
  VISUALIZAR_ATENDIDOS_TOTAL: 'Visualizar aba Atendidos - acesso total',
  VISUALIZAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS: 'Visualizar configurações da Gestão de Atendidos',
  VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ATENDIDOS: 'Visualizar frequência e histórico',
  VISUALIZAR_TURMAS_GRUPOS_GESTAO_DE_ATENDIDOS: 'Visualizar turmas e grupos',
  VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ATENDIDOS: 'Visualizar turmas e grupos',
  VISUALIZAR_HISTORICO_ALTERACOES_ATENDIDOS: 'Visualizar histórico de alterações de atendidos',
  GERENCIAR_GESTAO_DE_ATENDIDOS: 'Criar/editar/excluir Gestão de Atendidos',
  GERENCIAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS: 'Criar/editar/excluir configurações da Gestão de Atendidos',
  GERENCIAR_FREQUENCIA_GESTAO_DE_ATENDIDOS: 'Criar/editar/excluir frequência',
  GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ATENDIDOS: 'Inserir/alterar/excluir atestados e ausências de atendidos',

...classDiaryPermissionLabels,
};

const capitalize = (text) =>
  text
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getPermissionAliases = (permissionName) => {
  const normalizedName = normalizePermissionName(permissionName);
  const directKey = Object.keys(PERMISSION_ALIASES).find(
    (key) => normalizePermissionName(key) === normalizedName,
  );
  if (directKey) {
    return Array.from(new Set([directKey, ...(PERMISSION_ALIASES[directKey] || [])]));
  }

  const reverseEntry = Object.entries(PERMISSION_ALIASES).find(([, aliases]) =>
    aliases.some((alias) => normalizePermissionName(alias) === normalizedName),
  );
  if (reverseEntry) {
    const [key, aliases] = reverseEntry;
    return Array.from(new Set([key, ...aliases]));
  }

  return [permissionName];
};

const findMenuPermissionEntry = (permissionName) => {
  const normalizedName = normalizePermissionName(permissionName);
  return Object.entries(MENU_PERMISSION_ALIASES).find(([name, aliases]) =>
    [name, ...aliases]
      .map((alias) => normalizePermissionName(alias))
      .includes(normalizedName),
  );
};

export const MENU_PERMISSION_NAMES = Object.freeze(
  Object.keys(MENU_PERMISSION_ALIASES),
);

export const isMenuPermissionName = (permissionName) =>
  Boolean(findMenuPermissionEntry(permissionName));

export const hasMenuPermission = (user, permissionName) => {
  if (!user?.group?.permissions) return false;
  const entry = findMenuPermissionEntry(permissionName);
  if (!entry) return false;

  const [canonicalName, aliases] = entry;
  const acceptedNames = new Set(
    [canonicalName, ...aliases].map((alias) => normalizePermissionName(alias)),
  );

  return user.group.permissions
    .filter((permission) => permission?.visible !== false)
    .some((permission) =>
      acceptedNames.has(normalizePermissionName(permission?.name)),
    );
};

export const hasPermission = (user, permissionName) => {
  if (!user?.group?.permissions) return false;
  const userPermissions = new Set(
    user.group.permissions
      .filter((perm) => perm?.visible !== false)
      .map((perm) => normalizePermissionName(perm.name)),
  );
  return getPermissionAliases(permissionName)
    .map((alias) => normalizePermissionName(alias))
    .some((alias) => userPermissions.has(alias));
};

export const isAdmin = (user) => hasPermission(user, 'ADMINISTRADOR');

export const canAccessMenuRequirement = (user, permissionName) => {
  if (user?.isMaster) return true;
  if (isMenuPermissionName(permissionName)) {
    return hasMenuPermission(user, permissionName);
  }
  return hasPermission(user, permissionName) || isAdmin(user);
};

export const canManageNashAiIntegration = (user) =>
  Boolean(user?.isMaster || isAdmin(user));

export const hasAnyPermission = (user) =>
  Array.isArray(user?.group?.permissions) && user.group.permissions.length > 0;

// Compatibilidade com consumidores existentes: acesso agora exige permissão explícita.
export const canAccessWithoutPermission = () => false;

export const formatPermissionName = (permissionName) => {
  const normalizedName = normalizePermissionName(permissionName);
  const directKeyEntry = Object.keys(PERMISSION_ALIASES).find(
    (key) => normalizePermissionName(key) === normalizedName
  );
  const aliasEntry =
    directKeyEntry ||
    Object.entries(PERMISSION_ALIASES).find(([, aliases]) =>
      aliases.some((alias) => normalizePermissionName(alias) === normalizedName)
    )?.[0];
  const baseName = aliasEntry || normalizedName;
  if (LABEL_OVERRIDES[baseName]) {
    return LABEL_OVERRIDES[baseName];
  }
  return capitalize(baseName);
};

export const ADMIN_PERMISSION = 'ADMINISTRADOR';
export const MODELER_PERMISSION = 'MODELADOR';
export const PROCESS_MANAGER_PERMISSION = 'GERENCIAR_PROCESSOS';
export const CONFIDENTIAL_ACCESS_PERMISSION = 'ACESSO_CONFIDENCIAL';
export const FILE_MANAGER_PERMISSION = 'GERENCIAR_ARQUIVOS';
export const FORM_MANAGER_PERMISSION = 'GERENCIAR_FORMULARIOS';
export const COMPANY_MANAGER_PERMISSION = 'GERENCIAR_EMPRESA';
export const FINANCE_MANAGE_PERMISSION = 'GERENCIAR_FINANCEIRO';
export const FINANCE_VIEW_PERMISSION = 'VISUALIZAR_FINANCEIRO';
export const INVENTORY_MANAGE_PERMISSION = 'GERENCIAR_ESTOQUE';
export const INVENTORY_VIEW_PERMISSION = 'VISUALIZAR_ESTOQUE';
export const CRM_MANAGE_PERMISSION = 'GERENCIAR_CRM';
export const CRM_VIEW_PERMISSION = 'VISUALIZAR_CRM';
export const ASSET_MANAGE_PERMISSION = 'GERENCIAR_PATRIMONIO';
export const ASSET_VIEW_PERMISSION = 'VISUALIZAR_PATRIMONIO';
export const PROJECT_BANK_MANAGE_PERMISSION = 'GERENCIAR_BANCO_PROJETOS';
export const PROJECT_BANK_VIEW_PERMISSION = 'VISUALIZAR_BANCO_PROJETOS';
export const PROJECT_BANK_CREATE_PERMISSION = 'CRIAR_BANCO_PROJETOS';
export const PROJECT_BANK_DELETE_PERMISSION = 'EXCLUIR_BANCO_PROJETOS';
export const PROJECT_BANK_UPDATE_PERMISSION = 'ALTERAR_BANCO_PROJETOS';
export const PROJECT_BANK_SETTINGS_VIEW_PERMISSION = 'VISUALIZAR_CONFIGURACOES_BANCO_PROJETOS';
export const PROJECT_BANK_PROJECTS_TAB_PERMISSION = 'ACESSAR_ABA_PROJETOS_BANCO_PROJETOS';
export const HUMAN_RESOURCES_MANAGE_PERMISSION = 'GERENCIAR_RECURSOS_HUMANOS';
export const HUMAN_RESOURCES_VIEW_PERMISSION = 'VISUALIZAR_RECURSOS_HUMANOS';
export const PROCESS_UPDATE_PERMISSION = 'ATUALIZAR_PROCESSOS';
export const PROCESS_DELETE_PERMISSION = 'EXCLUIR_PROCESSOS';
export const PROCESS_EXECUTE_PERMISSION = 'EXECUTAR_PROCESSOS';
export const REGISTRATION_MANAGE_PERMISSION = 'GERENCIAR_CADASTROS';
export const REGISTRATION_VIEW_PERMISSION = 'VISUALIZAR_CADASTROS';
export const FORM_CREATE_PERMISSION = 'CRIAR_FORMULARIOS';
export const FORM_UPDATE_PERMISSION = 'ATUALIZAR_FORMULARIOS';
export const FORM_DELETE_PERMISSION = 'EXCLUIR_FORMULARIOS';
export const MURAL_CREATE_PERMISSION = 'CRIAR_AVISOS_MURAL';
export const MURAL_UPDATE_PERMISSION = 'ATUALIZAR_AVISOS_MURAL';
export const MURAL_DELETE_PERMISSION = 'EXCLUIR_AVISOS_MURAL';
export const CALENDAR_SHARE_PERMISSION = 'COMPARTILHAR_EVENTOS';
export const DASHBOARD_MENU_PERMISSION = 'VISUALIZAR_MENU_DASHBOARD';
export const AUTOMATION_MENU_PERMISSION = 'VISUALIZAR_MENU_AUTOMACOES';
export const STUDIO_MENU_PERMISSION = 'VISUALIZAR_MENU_STUDIO';
export const COURSES_MENU_PERMISSION = 'VISUALIZAR_MENU_CURSOS';
export const COURSES_VIEW_PERMISSION = 'VISUALIZAR_CURSOS';
export const COURSE_EDITOR_VIEW_PERMISSION = 'VISUALIZAR_EDICAO_CURSOS';
export const CONTENT_CREATOR_PERMISSION = 'CRIADOR_DE_CONTEUDO';
export const COURSE_COORDINATOR_PERMISSION = 'COORDENADOR_DE_CURSOS';
export const COURSE_CLASS_MANAGER_PERMISSION = 'GERENCIAR_TURMAS';
export const STUDIO_ASSISTANT_MENU_PERMISSION = 'VISUALIZAR_MENU_ASSISTENTE_IA';
export const STUDIO_FORMS_MENU_PERMISSION = 'VISUALIZAR_MENU_FORMULARIOS';
export const STUDIO_PROCESSES_MENU_PERMISSION = 'VISUALIZAR_MENU_PROCESSOS';
export const FILE_MANAGER_MENU_PERMISSION = 'VISUALIZAR_MENU_ARQUIVOS';
export const AGENDA_MENU_PERMISSION = 'VISUALIZAR_MENU_AGENDA';
export const BUSINESS_MENU_PERMISSION = 'VISUALIZAR_MENU_NEGOCIO';
export const REGISTRATION_MENU_PERMISSION = 'VISUALIZAR_MENU_CADASTROS';
export const REQUESTS_MENU_PERMISSION = 'VISUALIZAR_MENU_SOLICITACOES';
export const SETTINGS_MENU_PERMISSION = 'VISUALIZAR_MENU_CONFIGURACOES';
export const BUSINESS_COMPANY_MENU_PERMISSION = 'VISUALIZAR_MENU_DADOS_CADASTRAIS';
export const BUSINESS_FINANCE_MENU_PERMISSION = 'VISUALIZAR_MENU_FINANCEIRO';
export const BUSINESS_INVENTORY_MENU_PERMISSION = 'VISUALIZAR_MENU_ESTOQUE';
export const BUSINESS_ASSET_MENU_PERMISSION = 'VISUALIZAR_MENU_PATRIMONIO';
export const BUSINESS_CRM_MENU_PERMISSION = 'VISUALIZAR_MENU_CRM';
export const BUSINESS_HR_MENU_PERMISSION = 'VISUALIZAR_MENU_RECURSOS_HUMANOS';
export const BUSINESS_ORG_CHART_MENU_PERMISSION = 'VISUALIZAR_MENU_ORGANOGRAMA';
export const BUSINESS_PROJECT_BANK_MENU_PERMISSION = 'VISUALIZAR_MENU_BANCO_PROJETOS';
export const INTEGRATION_LOGS_PERMISSION = 'LOGS_DE_INTEGRACAO';
export const STUDENT_MANAGEMENT_MENU_PERMISSION = 'VISUALIZAR_MENU_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_DP_VIEW_PERMISSION = 'VISUALIZAR_ALUNOS_DP';
export const STUDENT_MANAGEMENT_FULL_VIEW_PERMISSION = 'VISUALIZAR_ALUNOS_TOTAL';
export const STUDENT_MANAGEMENT_FAMILY_VIEW_PERMISSION = 'VISUALIZAR_ABA_FAMILIA_ALUNOS';
export const STUDENT_MANAGEMENT_AUTHORIZATIONS_VIEW_PERMISSION = 'VISUALIZAR_ABA_AUTORIZACOES_ALUNOS';
export const STUDENT_MANAGEMENT_ADDRESS_VIEW_PERMISSION = 'VISUALIZAR_ABA_ENDERECO_ALUNOS';
export const STUDENT_MANAGEMENT_SOCIAL_VIEW_PERMISSION = 'VISUALIZAR_ABA_SOCIAL_ALUNOS';
export const STUDENT_MANAGEMENT_EDUCATION_VIEW_PERMISSION = 'VISUALIZAR_ABA_ESCOLARIDADE_ALUNOS';
export const STUDENT_MANAGEMENT_HEALTH_VIEW_PERMISSION = 'VISUALIZAR_ABA_SAUDE_ALUNOS';
export const STUDENT_MANAGEMENT_COURSE_VIEW_PERMISSION = 'VISUALIZAR_ABA_CURSO_ALUNOS';
export const STUDENT_MANAGEMENT_FILES_VIEW_PERMISSION = 'VISUALIZAR_ABA_ARQUIVOS_ALUNOS';
export const STUDENT_MANAGEMENT_FILES_MANAGE_PERMISSION = 'GERENCIAR_ARQUIVOS_ALUNOS';
export const STUDENT_MANAGEMENT_INCIDENTS_VIEW_PERMISSION = 'VISUALIZAR_ABA_INTERCORRENCIAS_ALUNOS';
export const STUDENT_MANAGEMENT_INCIDENTS_MANAGE_PERMISSION = 'GERENCIAR_INTERCORRENCIAS_ALUNOS';
export const STUDENT_MANAGEMENT_CUSTOM_TABS_VIEW_PERMISSION = 'VISUALIZAR_ABAS_EXTRAS_ALUNOS';
export const STUDENT_MANAGEMENT_SETTINGS_VIEW_PERMISSION = 'VISUALIZAR_CONFIGURACOES_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_ATTENDANCE_VIEW_PERMISSION = 'VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_CLASSES_COURSES_VIEW_PERMISSION = 'VISUALIZAR_TURMAS_CURSOS_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_CHANGE_HISTORY_VIEW_PERMISSION = 'VISUALIZAR_HISTORICO_ALTERACOES_ALUNOS';
export const STUDENT_MANAGEMENT_MANAGE_PERMISSION = 'GERENCIAR_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_SETTINGS_MANAGE_PERMISSION = 'GERENCIAR_CONFIGURACOES_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_ATTENDANCE_MANAGE_PERMISSION = 'GERENCIAR_FREQUENCIA_GESTAO_DE_ALUNOS';
export const STUDENT_MANAGEMENT_ABSENCE_MANAGE_PERMISSION = 'GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ALUNOS';
export const ATTENDEE_MANAGEMENT_MENU_PERMISSION = 'VISUALIZAR_MENU_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_DP_VIEW_PERMISSION = 'VISUALIZAR_ATENDIDOS_DP';
export const ATTENDEE_MANAGEMENT_FULL_VIEW_PERMISSION = 'VISUALIZAR_ATENDIDOS_TOTAL';
export const ATTENDEE_MANAGEMENT_SETTINGS_VIEW_PERMISSION = 'VISUALIZAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_ATTENDANCE_VIEW_PERMISSION = 'VISUALIZAR_FREQUENCIA_HISTORICO_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_CLASSES_GROUPS_VIEW_PERMISSION = 'VISUALIZAR_TURMAS_GRUPOS_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_CLASSES_COURSES_VIEW_PERMISSION = ATTENDEE_MANAGEMENT_CLASSES_GROUPS_VIEW_PERMISSION;
export const ATTENDEE_MANAGEMENT_CHANGE_HISTORY_VIEW_PERMISSION = 'VISUALIZAR_HISTORICO_ALTERACOES_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_MANAGE_PERMISSION = 'GERENCIAR_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_SETTINGS_MANAGE_PERMISSION = 'GERENCIAR_CONFIGURACOES_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_ATTENDANCE_MANAGE_PERMISSION = 'GERENCIAR_FREQUENCIA_GESTAO_DE_ATENDIDOS';
export const ATTENDEE_MANAGEMENT_ABSENCE_MANAGE_PERMISSION = 'GERENCIAR_ATESTADOS_AUSENCIAS_GESTAO_DE_ATENDIDOS';
export const TRASH_MENU_PERMISSION = 'VISUALIZAR_MENU_LIXEIRA';
export const SETTINGS_GROUPS_MENU_PERMISSION = 'VISUALIZAR_MENU_GRUPOS';
export const SETTINGS_USERS_MENU_PERMISSION = 'VISUALIZAR_MENU_USUARIOS';
export const SETTINGS_AUDIT_MENU_PERMISSION = 'VISUALIZAR_MENU_AUDITORIA';
export const SETTINGS_MAIL_MENU_PERMISSION = 'VISUALIZAR_MENU_EMAIL';
export const SETTINGS_USER_MANUAL_MENU_PERMISSION = 'VISUALIZAR_MENU_MANUAL_DO_USUARIO';
export const SETTINGS_PROFILE_MENU_PERMISSION = 'VISUALIZAR_MENU_PERFIL';
export const SETTINGS_MY_TEAM_MENU_PERMISSION = 'VISUALIZAR_MENU_MINHA_EQUIPE';

export const TRASH_MANAGER_PERMISSIONS = [
  PROCESS_MANAGER_PERMISSION,
  FORM_MANAGER_PERMISSION,
  FILE_MANAGER_PERMISSION,
  PROJECT_BANK_MANAGE_PERMISSION,
];

export const canManageTrash = (user) => {
  if (isAdmin(user)) {
    return true;
  }

  if (!hasPermission(user, TRASH_MENU_PERMISSION)) {
    return false;
  }

  return TRASH_MANAGER_PERMISSIONS.some((permission) => hasPermission(user, permission));
};

/* diary-tab-permission-labels-v1 */
